<template>
    <AppSection>
        <template #body>
            <div class="UiInfoCard" :class="{'UiInfoCard--reversed': !ltr}">
                <div class="UiInfoCard__left">
                    <img :src="img?img:params.img" alt="">
                </div>
                <div class="UiInfoCard__right">
                    <div class="UiInfoCard__content">
                        <h2 v-if="params?.title">{{ params?.title }}</h2>
                        <div v-if="params?.html" v-html="params.html"></div>
                        <slot></slot>
                        <ul v-if="params?.items">
                            <li v-for="item in params.items" v-html="item"></li>
                        </ul>
                        <a v-if="params?.btn" :href="params.btn.url">
                            <ABtn :label="params.btn.label" class="primary" />
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </AppSection>
</template>

<script>
import AppSection from "../AppSection";
import {ABtn} from "../ui";

/**
 * A component for displaying content divided by 2 parts - image and info
 * https://i.imgur.com/o2MYm0O.png - reference
 */

export default {
    name: 'InfoCard',
    components: {AppSection, ABtn},
    props: {
        /**
         * property to specify position of content (left - image; right - text)
         */
        ltr: {
            type: Boolean,
            default: true,
        },
        img: String,
        params: Object,
        text: String,
    },
    setup() {

    }
}
</script>

<style lang="scss">
.UiInfoCard {
    display: flex;
    //margin: 55px 0;

    @include tablet {
        flex-direction: column;
    }

    &--reversed {
        flex-direction: row-reverse;

        @include tablet {
            flex-direction: column;
        }
    }

    & > div {
        flex: 1 0 50%;
    }

    &__left {
        img {
            width: 100%;
            height: 100%;
            background-size: cover;
            object-fit: cover;
        }
    }

    &__right {
        display: flex;
        align-items: center;
        background-color: #fff;
        padding-left: rem(125);
        padding-right: rem(15);
        padding-top: rem(15);
        padding-bottom: rem(15);

        @include tablet {
            padding: rem(45) rem(35) !important;
        }

        .UiInfoCard--reversed & {
            padding-right: rem(125);
            padding-left: rem(25);
        }
    }

    ::v-deep .mHeading {
        margin: 0;
        text-align: left;
        margin-bottom: rem(17);
    }

    p {
        font-weight: 500;
        font-size: rem(14);
        line-height: 250%;
    }

    ul {
        padding: rem(17) 0;
    }

    li {
        display: block;
        font-weight: 500;
        font-size: rem(14);
        line-height: 250%;
        list-style: inside url("/local/templates/main/img/icons/tick.svg");
        padding-left: rem(40);
        background-size: rem(25);
        background: url("/local/templates/main/img/icons/tick.svg") no-repeat 0 rem(10);
    }
}


</style>